import React from 'react';
import { connect } from 'react-redux';
import Const from './Const';
import { changeTimeRange, REDUCER_NAME } from './reducer';
import { I18n } from 'react-redux-i18n';
import Calendar from './Calendar';
import { isNotLoginOrExpired } from '../../../helpers/Common';
import EventEmitter, { SHOW_GUEST_POPUP } from '../../../helpers/EventEmitter';

class TimeRange extends React.Component {
  componentDidMount() {
    const { user, changeTimeRange, timeRange } = this.props;
    if (isNotLoginOrExpired(user) && Const.lockTimeRange.includes(timeRange)) {
      changeTimeRange(Const.defaultTimeRange);
    }
  }

  getClassName = key => {
    const { timeRange } = this.props;

    return `btn btn-cus-nomal bg-b-color-3 ${
      key === timeRange ? 'active' : ''
    }`;
  };

  handleClick = key => () => {
    const { changeTimeRange, user } = this.props;
    if (isNotLoginOrExpired(user) && Const.lockTimeRange.includes(key)) {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
      return;
    }
    changeTimeRange(key);
  };

  render() {
    const { user } = this.props;
    return (
      <div>
        <div className="d-flex">
          <div className="btn-groupcus-line">
            {Const.listTimeRange.map(key => {
              const tabText = I18n.t(
                `marketInDepthValuation.tab.${
                  Const.listTimeRangeByKey[key].name
                }`,
              );

              return (
                <a
                  key={key}
                  href="#"
                  className={this.getClassName(key)}
                  onClick={this.handleClick(key)}
                >
                  {tabText}
                  {Const.lockTimeRange.includes(key) &&
                    isNotLoginOrExpired(user) && <i className="icon-padlock" />}
                </a>
              );
            })}
          </div>
          <Calendar />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    timeRange: state[REDUCER_NAME].timeRange,
    user: state.userInfo,
  };
};

const mapDispatchToProps = {
  changeTimeRange,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TimeRange);
